import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SubmissionError from './SubmissionError';
import ValidationErrors from './ValidationErrors';
import { donationFormHideSubmitError } from '../../../store/Slices/cnet/donationFormSlice';

const DonationFormAlert = ({
  formErrorMessage = null,
  submitting = false,
  submitFailed = false,
  hasValidationErrors = false,
  errors = {},
  showError = false,
  dispatch,
}) => {
  const onCloseClick = useCallback(() => {
    dispatch(donationFormHideSubmitError());
  }, [dispatch]);

  useEffect(() => {
    if (!formErrorMessage && showError && !hasValidationErrors) {
      onCloseClick();
    }
  }, [formErrorMessage, showError, hasValidationErrors, onCloseClick]);

  if (!showError) {
    return null;
  }

  if (submitFailed && hasValidationErrors) {
    return <ValidationErrors errors={errors} />;
  }

  if (!formErrorMessage || submitting) {
    return null;
  }

  return (
    <SubmissionError
      onCloseClick={onCloseClick}
      message={formErrorMessage.message}
      additionalMessage={formErrorMessage.additionalMessage}
      subline={formErrorMessage.subline}
    />
  );
};

DonationFormAlert.propTypes = {
  formErrorMessage: PropTypes.shape({
    message: PropTypes.string,
    subline: PropTypes.string,
    additionalMessage: PropTypes.string,
  }),
  submitting: PropTypes.bool,
  submitFailed: PropTypes.bool,
  hasValidationErrors: PropTypes.bool,
  errors: PropTypes.shape({}),
  dispatch: PropTypes.func.isRequired,
  showError: PropTypes.bool,
};

const mapStateToProps = ({
  donationForm: {
    formErrorMessage,
    showError,
    form: { submitting, submitFailed, hasValidationErrors, errors },
  },
}) => ({
  formErrorMessage,
  submitting,
  submitFailed,
  hasValidationErrors,
  errors,
  showError,
});

export default connect(mapStateToProps)(DonationFormAlert);
